import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const CATEGORIES = [
  { key: "relationship", label: "Relationship Drama", color: "bg-[#FFAEBC]" },
  { key: "friendship", label: "Friendship Beef", color: "bg-[#B4F8C8]" },
  { key: "daily-life", label: "Daily Life Dilemma", color: "bg-[#FFE600]" },
  { key: "family", label: "Family Chaos", color: "bg-[#A0E7E5]" },
  { key: "workplace", label: "Workplace Petty", color: "bg-[#FFD6A5]" },
];

export const categoryColor = (key) =>
  (CATEGORIES.find((c) => c.key === key) || {}).color || "bg-white";

export const categoryLabel = (key) =>
  (CATEGORIES.find((c) => c.key === key) || {}).label || key;

export const verdictColor = (v) => {
  switch ((v || "").toUpperCase()) {
    case "GUILTY":
      return "text-[#FF3B30]";
    case "NOT GUILTY":
      return "text-emerald-700";
    case "BOTH AT FAULT":
      return "text-amber-700";
    case "MISTRIAL":
      return "text-purple-700";
    case "CASE DISMISSED":
      return "text-slate-700";
    default:
      return "text-[#0A0A0A]";
  }
};
